import React, { useMemo, useRef, useState } from "react";
import ReactQuill from "react-quill-new";

type ReactQuillType = InstanceType<typeof ReactQuill>;
export interface NotesContextType {
  editingName?: string;
  setEditingName: React.Dispatch<React.SetStateAction<string>>;
  isEditorFocused: boolean;
  setIsEditorFocused: React.Dispatch<React.SetStateAction<boolean>>;
  editorRef: React.RefObject<ReactQuillType | null>;
}

export const NotesContext = React.createContext<NotesContextType>({} as NotesContextType);

export interface NotesProviderProps {
  readonly children?: React.ReactNode;
}

export function NotesProvider({ children }: NotesProviderProps) {
  const [editingName, setEditingName] = useState("Edit Note");
  const [isEditorFocused, setIsEditorFocused] = useState(false);

  const editorRef = useRef<ReactQuillType>(null);

  const contextValue = useMemo(
    () => ({ editingName, setEditingName, isEditorFocused, setIsEditorFocused, editorRef }),
    [editingName, isEditorFocused],
  );

  return <NotesContext.Provider value={contextValue}>{children}</NotesContext.Provider>;
}
